import { createBlock, openBlock, unref, mergeProps } from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, RadarChart, BarChart, TreeChart, HeatmapChart, LineChart } from "echarts/charts";
import { TitleComponent, TooltipComponent, LegendComponent, ToolboxComponent, GridComponent, VisualMapComponent, DataZoomComponent } from "echarts/components";
import VChart from "vue-echarts";
const _sfc_main = {
  __name: "BanzaChart",
  props: {
    option: Object
  },
  setup(__props) {
    use([
      CanvasRenderer,
      PieChart,
      RadarChart,
      BarChart,
      TreeChart,
      HeatmapChart,
      LineChart,
      // Cmponents
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      ToolboxComponent,
      GridComponent,
      VisualMapComponent,
      DataZoomComponent
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(VChart), mergeProps({
        option: __props.option,
        autoresize: ""
      }, _ctx.$attrs), null, 16, ["option"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
